import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=1206cfda"
import script from "./reset-password.vue?vue&type=script&lang=js"
export * from "./reset-password.vue?vue&type=script&lang=js"
import style0 from "./reset-password.vue?vue&type=style&index=0&id=1206cfda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports